import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getEnterPicks, getStandings, getNflScoreboard } from '@severed-links/common.redherrings-reducers/terminator'
import terminatorErrorMessage from './terminatorErrorMessage'
export default function useTerminatorCurrentWeek() {
  const dispatch = useDispatch()
  const state = useSelector(state => state.terminator)
  const { seasonId, seasonMode, week, playoffWeek, enterPicks, standings, nflScoreboards } = state
  const currentWeek = seasonMode === 'Postseason' ? playoffWeek : week
  const [now, setNow] = useState(Date.now())
  const [error, setError] = useState('')
  useEffect(() => {
    if (!seasonId || !['Regular', 'Postseason'].includes(seasonMode)) return
    let active = true
    const load = async () => {
      try {
        const results = await Promise.all([dispatch(getEnterPicks()), dispatch(getStandings(seasonId)), dispatch(getNflScoreboard(seasonId, currentWeek, seasonMode === 'Postseason'))])
        if (results.some(result => result.error)) throw new Error('Unable to refresh the current picks.')
        if (active) { setError(''); setNow(Date.now()) }
      } catch (error) { if (active) setError(terminatorErrorMessage(error)) }
    }
    load()
    const timer = setInterval(load, 30000)
    const clock = setInterval(() => setNow(Date.now()), 1000)
    return () => { active = false; clearInterval(timer); clearInterval(clock) }
  }, [dispatch, seasonId, seasonMode, currentWeek])
  const entry = ['Regular', 'Postseason'].includes(seasonMode) && enterPicks?.seasonId === seasonId && enterPicks.seasonMode === seasonMode && enterPicks.week === currentWeek ? enterPicks : null
  const pick = entry?.picks?.find(p => p.isCurrentPick)
  const scoreboard = nflScoreboards?.find(board => board.seasonId === seasonId && board.weekNumber === currentWeek && board.isPlayoffWeek === (seasonMode === 'Postseason'))
  const game = pick?.teamId ? scoreboard?.gameDays?.flatMap(day => day.games || []).find(g => [String(g.home), String(g.visitor)].includes(String(pick.teamId))) || entry?.games?.find(g => [String(g.home), String(g.visitor)].includes(String(pick.teamId))) : null
  const table = standings?.[seasonId]
  const current = table?.weeks?.find(w => w.seasonMode === seasonMode && w.week === currentWeek)
  const rows = table?.scoreboardPlayers || []
  const counts = new Map()
  if (current?.isAfterDeadline) rows.forEach(player => {
    const p = player.picks?.find(p => p.weekDisplay === current.weekDisplay && p.isAfterDeadline)
    if (!p) return
    const key = p.teamId || 'none'
    const item = counts.get(key) || { teamId: key, nflTeam: p.nflTeam || 'No pick', mascot: p.mascot, count: 0 }
    item.count++
    counts.set(key, item)
  })
  return { entry, pick, game, error, afterDeadline: !!current?.isAfterDeadline, report: [...counts.values()].sort((a, b) => b.count - a.count), playerCount: rows.length, canEnterPick: !!entry?.canEnterPick && now < new Date(entry.deadline).getTime() }
}
